import { Toast as Toasts } from 'primereact/toast';  

const Toast = ({...rest}) => {

    return (
        <Toasts {...rest} />
    )

};

export default Toast;